import { ID } from '../../utils/codecUtils';
import { integrationCredentialSchema } from '../models/integrationCredential.schema';

export const get = (integrationCredentialId: ID) => {
  return {
    endpoint: `/integration_credentials/${integrationCredentialId}`,
    method: 'GET',
    responseSchema: integrationCredentialSchema,
  } as const;
};
